import React from 'react';
import {
  Form, Row, Input, Button, Space, Col
} from 'antd';
import PropTypes from 'prop-types';

const OtherSpecifications = (props) => {
  const { finish, setSpecifications } = props;

  const [form] = Form.useForm();

  const onFinish = values => {
    finish(values);
  };

  return (
    <Form
      form={form}
      onFinish={onFinish}
      layout="horizontal"
    >
      <Form.Item
        required
        shouldUpdate
        name="name"
        label="Titre du cachier des charges"
        labelAlign="left"
        rules={[
          {
            required: true,
            message: 'Champs requis',
          },
        ]}
      >
        <Input size="large" />
      </Form.Item>
      <Row justify="center">
        <Space wrap align="start" size="large" style={{ marginTop: '20px' }}>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <Form.Item>
              <Button type="primary" htmlType="submit">
                Valider le cahier des charges
              </Button>
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <Form.Item>
              <Button
                type="danger"
                onClick={() => setSpecifications(false)}
              >
                Annuler
              </Button>
            </Form.Item>
          </Col>
        </Space>
      </Row>
    </Form>
  );
};

OtherSpecifications.propTypes = {
  finish: PropTypes.func.isRequired,
  setSpecifications: PropTypes.func
};

export default OtherSpecifications;
